module.exports = __webpack_public_path__ + "static/media/morma.41f72e69.jpg";